import React from 'react';
import { connect } from 'react-redux';
import { editRombel } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import Modal from '../../../ui/Modal';
import Icon from '@mdi/react';
import { mdiShieldHalfFull } from '@mdi/js';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  editRombel,
};

function ModalDeleteItem({ data, closeModal, editRombel }) {
  const auth = data.auth;
  const history = data.history;
  const item = data.item;
  const classyear = item?.classyear;
  const student = item?.student;

  function onDelete() {
    let initStudents = classyear?.students && JSON.parse(classyear.students);
    let updateStudents = initStudents.filter(
      (s) => s.userId !== student.userId
    );
    let sortUpdateStudents = updateStudents.map((s, index) => {
      return { ...s, noabsen: index + 1 };
    });
    let updateClassyear = {
      ...classyear,
      students: JSON.stringify(sortUpdateStudents),
    };

    editRombel({
      auth,
      history,
      values: { id: classyear.id, classyears: [updateClassyear] },
    });
    closeModal();
  }

  return (
    <Modal closeModal={closeModal}>
      <div className='px-5'>
        <p className='has-text-info flex justify-start align-center is-size-5'>
          <span className='icon is-medium'>
            <Icon path={mdiShieldHalfFull} size={1} />
          </span>
          Konfirmasi
        </p>
        <p className='py-4 my-2 mx-2'>
          Apakah Anda yakin ingin menghapus siswa{' '}
          <span className='has-text-danger has-text-weight-semibold'>{`${student?.name}`}</span>{' '}
          ?
        </p>
        <div className='flex justify-end align-center pt-2'>
          <div className='buttons'>
            <Button
              cvariant='cdelete'
              withLabel={true}
              onClick={() => onDelete()}
            />
            <Button cvariant='cback' withLabel={true} onClick={closeModal} />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalDeleteItem);
